<svg
  width="8"
  height="8"
  viewBox="0 0 8 8"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <g clip-path="url(#clip0_2106_25577)">
    <path
      d="M0.916687 5.03125L3.00002 6.75L7.08335 1.25"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="square"
    />
  </g>
  <defs>
    <clipPath id="clip0_2106_25577">
      <rect width="8" height="8" fill="white" />
    </clipPath>
  </defs>
</svg>
